// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"43ba8b87","369":"321d10e5","618":"7d837a39","641":"ede2a2ac","967":"a00f595a"}[chunkId] + ".chunk.js";
};